import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AppointmentTypesUIState {
  expandableFields: Record<string, boolean>;
  selectedTypeId: string | null;
  isAddModalOpen: boolean;
}

const initialState: AppointmentTypesUIState = {
  expandableFields: {},
  selectedTypeId: null,
  isAddModalOpen: false,
};

export const appointmentTypesSlice = createSlice({
  name: 'appointmentTypes',
  initialState,
  reducers: {
    setExpandableFieldState: (
      state,
      action: PayloadAction<{
        fieldId: string;
        expanded: boolean;
      }>,
    ) => {
      const { fieldId, expanded } = action.payload;
      state.expandableFields[fieldId] = expanded;
    },

    toggleExpandableField: (state, action: PayloadAction<string>) => {
      const fieldId = action.payload;
      state.expandableFields[fieldId] = !state.expandableFields[fieldId];
    },

    selectAppointmentType: (state, action: PayloadAction<string | null>) => {
      state.selectedTypeId = action.payload;
    },

    setAddModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isAddModalOpen = action.payload;
    },

    resetUIState: () => initialState,
  },
});

export const {
  setExpandableFieldState,
  toggleExpandableField,
  selectAppointmentType,
  setAddModalOpen,
  resetUIState,
} = appointmentTypesSlice.actions;

export default appointmentTypesSlice.reducer;
